import React, { useState, useEffect } from "react";
import Home from "../Home";
import { getCapitalized } from "../../utils/Helper";
import { useForm } from "react-hook-form";
import { HELP_TEXT, PATHS } from "../../utils";
import { NavLink, useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import { useDispatch, useSelector } from "react-redux";
import {
  createEducationpg,
  getpgEducationDetail,
} from "../../redux/actions/Api";
import { toast } from "react-toastify";
import Success from "../notification/Success";
import Loader from "../Loader";
import { NUM_REGEX, EMAIL_REGEX } from "../../utils/Regex";
import { resetForms, unsavedchanges } from "../../redux/actions";
import Error from "../notification/Error";
import { Notes } from "../common/Notes";
import { CREATEEDUCATION_DETAIL_PG } from "../../redux/actions/Types";
import moment from "moment";
import {
  AppCommon,
  ApplicationViewPage,
  PGEducationDetails,
  UGEducationDetails,
} from "../constantLabelFile";
import {
  APF_EMAIL_DOMAIN,
  hasEmailDomain,
} from "../../utils/programPreference";

let DraftBtn = "";
let bachelorsStatus = [];
let bachelorsStatusYear;
let natureDis = [];

const isNAOption = (value) => {
  const normalized = String(value ?? "")
    .trim()
    .toUpperCase()
    .replace(/[\s./]/g, "");
  return normalized === "NA";
};

const getDistrictsByState = (districtsByCountry, stateValue) => {
  if (!stateValue || isNAOption(stateValue)) {
    return [];
  }
  const stateObject = districtsByCountry?.[stateValue];
  if (!stateObject || typeof stateObject !== "object") {
    return [];
  }
  return Object.values(stateObject);
};

const getSelectableStates = (states) =>
  (states || []).filter(
    (stateobj) => !isNAOption(stateobj?.Id) && !isNAOption(stateobj?.value)
  );

const EducationDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    picklistdata,
    error,
    pgedudata,
    pgEducationdetailres,
    dashboardresponse,
    bachelorsCompletionStatus,
  } = useSelector((state) => state.collections);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
  });

  const workedWithApf = watch("workedWithApf");

  const [experience, setExprience] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectednewCountry, setSelectednewCountry] = useState("");
  const [selectedCountryTwelth, setSelectedCountryTwelth] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [district, setDistrict] = useState([]);

  const [selectedStateTwelth, setSelectedStateTwelth] = useState("");
  const [selectedDistrictTwelth, setSelectedDistrictTwelth] = useState("");
  const [districtTwelth, setDistrictTwelth] = useState([]);

  const [selectedState1, setSelectedState1] = useState("");
  const [selectedDistrict1, setSelectedDistrict1] = useState("");
  const [district1, setDistrict1] = useState([]);
  const [loader, setLoader] = useState(true);
  const [pickListVal, setPickListVal] = useState("");
  const [medInsti, setMedInsti] = useState("");
  const [mediumInsti, setMediumInsti] = useState("");
  const [pgDegree, setPgdegree] = useState("");
  const [allEduresponsedata, setAllEduresponsedata] = useState("");

  const [readOnly, setReadOnly] = useState(false);
  const [showMsg, setShowMsg] = useState("");

  const [tenthMedium, setTenthMedium] = useState("");
  const [twelvthMedium, setTwelvthMedium] = useState("");

  useEffect(() => {
    if (pgEducationdetailres == undefined) {
      setLoader(true);
    } else {
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    }
  }, [pgEducationdetailres]);

  useEffect(() => {
    setAllEduresponsedata(pgEducationdetailres?.data?.records[0]);
  }, [pgEducationdetailres]);

  useEffect(() => {
    bachelorsStatus = bachelorsCompletionStatus?.Value?.split(",");
    bachelorsStatusYear =
      dashboardresponse?.data?.allDataOnDashboard[0]?.appCycleEndDateYear;
    if (bachelorsStatus && bachelorsStatusYear) {
      bachelorsStatus = {
        ...bachelorsStatus,
        1: `${bachelorsStatus[1]} ${bachelorsStatusYear}`,
      };
    }
  }, [bachelorsCompletionStatus, dashboardresponse]);

  useEffect(() => {
    if (
      allEduresponsedata?.hed__Education_History__r &&
      picklistdata &&
      pickListVal
    ) {
      setValue(
        "schoolNameTenth",
        allEduresponsedata?.hed__Education_History__r?.records[0]?.hed__Educational_Institution_Name__c
      );
      setValue(
        "schoolNameTwelveth",
        allEduresponsedata?.hed__Education_History__r?.records[1]?.hed__Educational_Institution_Name__c
      );
      setValue("countryTenth", allEduresponsedata?.hed__Education_History__r?.records[0]?.Country__c);
      setSelectedCountry(allEduresponsedata?.hed__Education_History__r?.records[0]?.Country__c);
      setValue("countryTwelveth", allEduresponsedata?.hed__Education_History__r?.records[1]?.Country__c);
      setSelectedCountryTwelth(allEduresponsedata?.hed__Education_History__r?.records[1]?.Country__c);
      setValue(
        "otherCountrySpecifyTenth",
        allEduresponsedata.hed__Education_History__r?.records[0]?.Please_Specify_Country__c
      );
      setValue(
        "otherCountrySpecifyTwelveth",
        allEduresponsedata.hed__Education_History__r?.records[1]?.Please_Specify_Country__c
      );
      setValue("stateTenth", allEduresponsedata?.hed__Education_History__r?.records[0]?.State__c);
      setSelectedState(allEduresponsedata?.hed__Education_History__r?.records[0]?.State__c);

      if (pickListVal && allEduresponsedata?.hed__Education_History__r?.records[0]?.Country__c === "India") {
        setDistrict(
          getDistrictsByState(
            pickListVal?.districts?.India,
            allEduresponsedata?.hed__Education_History__r?.records[0]?.State__c
          )
        );
      }
      if (pickListVal && allEduresponsedata?.hed__Education_History__r?.records[1]?.Country__c === "India") {
        setDistrictTwelth(
          getDistrictsByState(
            pickListVal?.districts?.India,
            allEduresponsedata?.hed__Education_History__r?.records[1]?.State__c
          )
        );
      }

      setValue("stateTwelveth", allEduresponsedata?.hed__Education_History__r?.records[1]?.State__c);
      setSelectedStateTwelth(allEduresponsedata?.hed__Education_History__r?.records[1]?.State__c);
      setValue("districtTenth", allEduresponsedata?.hed__Education_History__r?.records[0]?.District__c);
      setSelectedDistrict(allEduresponsedata?.hed__Education_History__r?.records[0]?.District__c);
      setValue("districtTwelveth", allEduresponsedata?.hed__Education_History__r?.records[1]?.District__c);
      setSelectedDistrictTwelth(allEduresponsedata?.hed__Education_History__r?.records[1]?.District__c);
      setValue(
        "boardTenth",
        allEduresponsedata?.hed__Education_History__r?.records[0]?.School_College_Board__c
      );
      setValue(
        "boardTwelth",
        allEduresponsedata?.hed__Education_History__r?.records[1]?.School_College_Board__c
      );

      setValue("passingYearTenth", allEduresponsedata?.hed__Education_History__r?.records[0]?.Year_Of_Passing__c)
      setValue("passingYearTwelveth", allEduresponsedata?.hed__Education_History__r?.records[1]?.Year_Of_Passing__c)
      setValue("schoolTypeTenth", allEduresponsedata?.hed__Education_History__r?.records[0]?.Type_of_School_College_Board__c)
      setValue("schoolTypeTwelveth", allEduresponsedata?.hed__Education_History__r?.records[1]?.Type_of_School_College_Board__c)
      setValue("mediumInstTenth", allEduresponsedata?.hed__Education_History__r?.records[0]?.Medium_of_instruction__c)
      setTenthMedium(allEduresponsedata?.hed__Education_History__r?.records[0]?.Medium_of_instruction__c)
      setValue("mediumInstTwelveth", allEduresponsedata?.hed__Education_History__r?.records[1]?.Medium_of_instruction__c)
      setTwelvthMedium(allEduresponsedata?.hed__Education_History__r?.records[1]?.Medium_of_instruction__c)
      setValue("specifyMediumTenth", allEduresponsedata?.hed__Education_History__r?.records[0]?.Please_Specify_Medium_of_Instruction__c)
      setValue("specifyMediumTwelveth", allEduresponsedata?.hed__Education_History__r?.records[1]?.Please_Specify_Medium_of_Instruction__c)
      setValue("residenceTenth", allEduresponsedata?.hed__Education_History__r?.records[0]?.Region_of_Residence__c)
      setValue("residenceTwelveth", allEduresponsedata?.hed__Education_History__r?.records[1]?.Region_of_Residence__c)

      // -------------------------------------------------------------------------
      setValue(
        "bachelorsCompletedByAug",
        allEduresponsedata?.hed__Education_History__r?.records[2]
          ?.Bachelors_complete_by_Aug1_NextYear__c
      );
      setValue(
        "qualificationsObtained",
        allEduresponsedata?.hed__Education_History__r?.records[2]
          ?.Qualification_obtained__c
      );
      setValue(
        "completionYear",
        allEduresponsedata?.hed__Education_History__r?.records[2]
          ?.Year_of_completion__c
      );
      setValue(
        "HaveUGEconomicsPassed",
        allEduresponsedata?.hed__Education_History__r?.records[2]
          ?.Have_you_passed_your_UG_Economics__c
      );
      setValue(
        "durationUndergraduateProg",
        allEduresponsedata?.hed__Education_History__r?.records[2]
          ?.APU_Duration_of_your_UG__c
      );

      setValue(
        "townCategoryTenth",
        allEduresponsedata?.hed__Education_History__r?.records[0]
          ?.Category_of_city_town_where_studied__c
      );
    
      setValue(
        "townCategoryGrad",
        allEduresponsedata?.hed__Education_History__r?.records[2]
          ?.Category_of_city_town_where_studied__c
      );
      setValue(
        "gradMode",
        allEduresponsedata?.hed__Education_History__r?.records[2]
          ?.Mode_of_graduation__c
      );
      setValue(
        "streamSpecialization",
        allEduresponsedata?.hed__Education_History__r?.records[2]
          ?.Stream_Specialization__c
      );
      setValue(
        "universityName",
        allEduresponsedata?.hed__Education_History__r?.records[2]
          ?.Name_of_the_University__c
      );
      setValue(
        "schoolNameGrad",
        allEduresponsedata?.hed__Education_History__r?.records[2]
          ?.hed__Educational_Institution_Name__c
      );
      setValue(
        "countryGrad",
        allEduresponsedata?.hed__Education_History__r?.records[2]?.Country__c
      );
      setSelectednewCountry(
        allEduresponsedata?.hed__Education_History__r?.records[2]?.Country__c
      );
      // setSelectedCountryTwelth()
      setValue(
        "otherCountrySpecifyGrad",
        allEduresponsedata?.hed__Education_History__r?.records[2]
          ?.Please_Specify_Country__c
      );
      setValue(
        "stateGrad",
        allEduresponsedata?.hed__Education_History__r?.records[2]?.State__c
      );
      if (pickListVal && allEduresponsedata?.hed__Education_History__r?.records[2]?.Country__c === "India") {
        setDistrict1(
          getDistrictsByState(
            pickListVal?.districts?.India,
            allEduresponsedata?.hed__Education_History__r?.records[2]?.State__c
          )
        );
      }
      setSelectedState1(
        allEduresponsedata?.hed__Education_History__r?.records[2]?.State__c
      );
      // setSelectedStateTwelth()
      setValue(
        "districtGrad",
        allEduresponsedata?.hed__Education_History__r?.records[2]?.District__c
      );

      setSelectedDistrict1(
        allEduresponsedata?.hed__Education_History__r?.records[2]?.District__c
      );

      setValue(
        "mediumInstGrad",
        allEduresponsedata?.hed__Education_History__r?.records[2]
          ?.Medium_of_instruction__c
      );
      setMediumInsti(
        allEduresponsedata?.hed__Education_History__r?.records[2]
          ?.Medium_of_instruction__c
      );
      setValue(
        "specifyMediumGrad",
        allEduresponsedata?.hed__Education_History__r?.records[2]
          ?.Please_Specify_Medium_of_Instruction__c
      );
      setValue(
        "havePGDegree",
        allEduresponsedata?.hed__Education_History__r?.records[2]
          ?.Do_you_have_any_Postgraduate_degree__c
      );
      setPgdegree(
        allEduresponsedata?.hed__Education_History__r?.records[2]
          ?.Do_you_have_any_Postgraduate_degree__c
      );
      setValue(
        "qualificationName",
        allEduresponsedata?.hed__Education_History__r?.records[2]
          ?.Name_on_Qualification__c
      );

      setValue(
        "workExperience",
        allEduresponsedata?.Work_experience_after_gr__c
      );
      setExprience(allEduresponsedata?.Work_experience_after_gr__c);
      setValue(
        "workExperienceInMonths",
        allEduresponsedata?.Work_experience_in_months__c
      );
      setValue(
        "AreCurrentlyEmployed",
        allEduresponsedata?.Are_you_currently_employed__c
      );
      setValue(
        "organization",
        allEduresponsedata?.Organization_where_you_are__c
      );
      setValue(
        "typeOfOrganization",
        allEduresponsedata?.Type_of_organization__c
      );
      setValue(
        "monthlyGrossSalary",
        allEduresponsedata?.Monthly_gross_salary_Rs__c
      );
      setValue(
        "annualGrossSalary",
        allEduresponsedata?.Annual_gross_salary_Rs__c
      );
      setValue(
        "workedWithApf",
        allEduresponsedata?.Worked_with_Azim_Premji_Foundation__c ||
          allEduresponsedata?.workedWithApf ||
          ""
      );
      setValue(
        "apfWorkEmail",
        allEduresponsedata?.APU_Work_Email_ID__c ||
          allEduresponsedata?.apfWorkEmail ||
          ""
      );
      setValue(
        "apfTeamDepartment",
        allEduresponsedata?.Team_Department__c ||
          allEduresponsedata?.apfTeamDepartment ||
          ""
      );
      setValue(
        "apfLocationOfWork",
        allEduresponsedata?.Location_of_work__c ||
          allEduresponsedata?.apfLocationOfWork ||
          ""
      );
    }
  }, [
    allEduresponsedata,
    picklistdata,
    pickListVal,
    bachelorsStatus,
    bachelorsStatusYear,
    bachelorsCompletionStatus,
  ]);

  useEffect(() => {
    if (error) {
      setLoader(false);
      toast.error(<Error error={error} />, {
        position: "top-center",
        autoClose: 5000,
        className: "Toastify__toast-theme--colored.Toastify__toast--warning",
      });
      setTimeout(() => {
        dispatch(resetForms());
      }, 5000);
    }
  }, [error]);

  useEffect(() => {
    let formData = {
      contactId: localStorage.getItem("contactId"),
      applicationId: localStorage.getItem("applicationId"),
    };
    if (formData) {
      dispatch(getpgEducationDetail(formData));
    }
  }, []);

  useEffect(() => {
    setPickListVal(picklistdata?.data);
  }, [picklistdata]);

  useEffect(() => {
    if (pickListVal) {
      natureDis = pickListVal?.typeOfOrganization;
      natureDis?.forEach(function (v, i) {
        if (v.Id == "Others") {
          natureDis?.push(natureDis[i]);
          natureDis?.splice(i, 1);
        }
      });
    }
  }, [natureDis, pickListVal]);

  let draftMsg = {
    message: "Details Saved Successfully.",
  };

  useEffect(() => {
    if (pgedudata) {
      dispatch(unsavedchanges());
      toast.success(<Success response={!DraftBtn ? pgedudata : draftMsg} />, {
        position: "top-center",
        autoClose: 2000,
      });
      setLoader(false);
      if (!DraftBtn) {
        setTimeout(() => {
          dispatch({ type: CREATEEDUCATION_DETAIL_PG, payload: undefined });
          navigate(
            PATHS.SOCIALECOPG_STR +
              dashboardresponse?.data?.allDataOnDashboard[0]?.appId
          );
        }, 500);
      } else if (DraftBtn) {
        setTimeout(() => {
          draftMsg.message = "";
          dispatch({ type: CREATEEDUCATION_DETAIL_PG, payload: undefined });
        }, 500);
      }
    }
  }, [pgedudata]);

  const handleExprience = (e) => {
    setExprience(e.target.value);
    dispatch(unsavedchanges(e.target.value));
    clearErrors("workExperience");
  };

  const handleState = (e) => {
    const stateValue = e.target.value;
    setSelectedState(stateValue);
    setDistrict(getDistrictsByState(pickListVal?.districts?.India, stateValue));
    setSelectedDistrict("");
    setValue("districtTenth", "");
    dispatch(unsavedchanges(stateValue));
    clearErrors("stateTenth");
    clearErrors("districtTenth");
  };

  const handlenewState = (e) => {
    const stateValue = e.target.value;
    setSelectedState1(stateValue);
    setDistrict1(getDistrictsByState(pickListVal?.districts?.India, stateValue));
    setSelectedDistrict1("");
    setValue("districtGrad", "");

    dispatch(unsavedchanges(stateValue));
    clearErrors("stateGrad");
    clearErrors("districtGrad");
  };

  const handlenewStateTwelth = (e) => {
    const stateValue = e.target.value;
    setSelectedStateTwelth(stateValue);
    setDistrictTwelth(
      getDistrictsByState(pickListVal?.districts?.India, stateValue)
    );
    setSelectedDistrictTwelth("");
    setValue("districtTwelveth", "");

    dispatch(unsavedchanges(stateValue));
    clearErrors("stateTwelveth");
    clearErrors("districtTwelveth");
  };

  const _onSubmit = (values) => {
    let formData = {
      userId: localStorage.getItem("userId"),
      contactId: localStorage.getItem("contactId"),
      applicationId: localStorage.getItem("applicationId"),

      schoolNameTenth: values.schoolNameTenth,
      schoolNameTwelveth: values.schoolNameTwelveth,
      countryTenth: values.countryTenth,
      countryTwelveth: values.countryTwelveth,
      otherCountrySpecifyTenth:
        values.countryTenth === "Others" ? values.otherCountrySpecifyTenth : "",
      otherCountrySpecifyTwelveth: values.otherCountrySpecifyTwelveth,
      stateTenth: values.countryTenth === "India" ? values.stateTenth ? values.stateTenth: "" : "",
      stateTwelveth: values.countryTwelveth === "India" ? values.stateTwelveth ? values.stateTwelveth : "" : "",
      districtTenth:
        values.countryTenth === "India" && !isNAOption(values.stateTenth)
          ? values.districtTenth
            ? values.districtTenth
            : null
          : null,
      districtTwelveth:
        values.countryTwelveth === "India" && !isNAOption(values.stateTwelveth)
          ? values.districtTwelveth
            ? values.districtTwelveth
            : null
          : null,
      boardTenth: values.boardTenth,
      boardTwelth: values.boardTwelth,
      passingYearTenth: parseInt(values.passingYearTenth),
      passingYearTwelveth: parseInt(values.passingYearTwelveth),
      schoolTypeTenth: values.schoolTypeTenth,
      schoolTypeTwelveth: values.schoolTypeTwelveth,
      mediumInstTenth: values.mediumInstTenth,
      mediumInstTwelveth: values.mediumInstTwelveth,
      specifyMediumTenth: tenthMedium === "Other" ? values.specifyMediumTenth : "",
      specifyMediumTwelveth: twelvthMedium === "Other" ? values.specifyMediumTwelveth : "",
      residenceTenth: values.residenceTenth,
      residenceTwelveth: values.residenceTwelveth,
      // townCategoryTenth: values.townCategoryTenth,

      bachelorsCompletedByAug: values.bachelorsCompletedByAug,
      qualificationsObtained: values.qualificationsObtained,
      completionYear: values.completionYear,
      durationUndergraduateProg: values.durationUndergraduateProg,
      // townCategoryTenth: values.townCategoryTenth,
      // countryTenth: values.countryTenth ? values.countryTenth : "",
      // otherCountrySpecifyTenth:
      //   values.countryTenth === "Others" ? values.otherCountrySpecifyTenth : "",
      // mediumInstTenth: values.mediumInstTenth ? values.mediumInstTenth : "",
      // specifyMediumTenth: values.specifyMediumTenth
      //   ? values.specifyMediumTenth
      //   : "",
      // stateTenth:
      //   values.countryTenth === "India"
      //     ? values.stateTenth
      //       ? values.stateTenth
      //       : ""
      //     : "",
      // districtTenth:
      //   values.countryTenth === "India"
      //     ? values.districtTenth
      //       ? values.districtTenth
      //       : null
      //     : null,
      townCategoryGrad: values.townCategoryGrad,
      gradMode: values.gradMode,
      streamSpecialization: values.streamSpecialization,
      universityName: values.universityName,
      schoolNameGrad: values.schoolNameGrad,
      countryGrad: values.countryGrad ? values.countryGrad : "",
      otherCountrySpecifyGrad:
        values.countryGrad === "Others" ? values.otherCountrySpecifyGrad : "",
      stateGrad:
        values.countryGrad === "India"
          ? values.stateGrad
            ? values.stateGrad
            : ""
          : "",
      districtGrad:
        values.countryGrad === "India" && !isNAOption(values.stateGrad)
          ? values.districtGrad
            ? values.districtGrad
            : null
          : null,
      mediumInstGrad: values.mediumInstGrad,
      specifyMediumGrad: values.specifyMediumGrad
        ? values.specifyMediumGrad
        : "",
      havePGDegree: values.havePGDegree,
      qualificationName:
        values.havePGDegree == "Yes" ? values.qualificationName : "",
      workExperience: values.workExperience,
      AreCurrentlyEmployed:
        values.workExperience === "Yes" ? values.AreCurrentlyEmployed : "",
      workExperienceInMonths:
        values.workExperience === "Yes"
          ? parseInt(values.workExperienceInMonths)
          : null,
      organization: values.workExperience === "Yes" ? values.organization : "",
      typeOfOrganization:
        values.workExperience === "Yes" ? values.typeOfOrganization : "",
      annualGrossSalary:
        values.workExperience === "Yes"
          ? parseInt(values.annualGrossSalary)
          : null,
      HaveUGEconomicsPassed: values.HaveUGEconomicsPassed
        ? values.HaveUGEconomicsPassed
        : "",
      workedWithApf: values.workedWithApf,
      apfWorkEmail:
        values.workedWithApf === "Yes" ? values.apfWorkEmail : "",
      apfTeamDepartment:
        values.workedWithApf === "Yes" ? values.apfTeamDepartment : "",
      apfLocationOfWork:
        values.workedWithApf === "Yes" ? values.apfLocationOfWork : "",
      allPGDetails: "",
    };

    if (formData) {
      setLoader(true);
      dispatch(createEducationpg(formData));
    }
  };

  const currentDate = new Date();
  const year1 = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const formattedDate = `${year1}-${month}-${day}`;

  useEffect(() => {
    if (
      allEduresponsedata?.hed__Applications_Applicant__r?.records[0]
        ?.hed__Application_Status__c === "Started" ||
      allEduresponsedata?.hed__Applications_Applicant__r?.records[0]
        ?.hed__Application_Status__c === "Draft" ||
      allEduresponsedata?.hed__Applications_Applicant__r?.records[0]
        ?.hed__Application_Status__c === "Payment Failed" ||
      allEduresponsedata?.hed__Applications_Applicant__r?.records[0]
        ?.hed__Application_Status__c === "Payment Pending" ||
      allEduresponsedata?.hed__Applications_Applicant__r?.records[0]
        ?.hed__Application_Status__c === "Payment Submitted"
    ) {
      if (
        formattedDate >
        allEduresponsedata?.hed__Applications_Applicant__r?.records[0]
          ?.Admission_Cycle__r?.Application_Submission_Date__c
      ) {
        setReadOnly(true);
        setShowMsg(<Notes name="ADM_Cycle_Validation_App" />);
      } else {
        setReadOnly(false);
        setShowMsg("");
      }
    } else {
      if (
        formattedDate <
        allEduresponsedata?.hed__Applications_Applicant__r?.records[0]
          ?.Admission_Cycle__r?.Application_Submission_Date__c
      ) {
        setReadOnly(true);
        setShowMsg("");
      } else {
        setReadOnly(true);
        setShowMsg(<Notes name="ADM_Cycle_Validation_App" />);
      }
    }
  }, [allEduresponsedata]);

  useEffect(() => {
    if (
      allEduresponsedata?.hed__Applications_Applicant__r?.records[0]
        ?.Not_Eligible__c
    ) {
      setReadOnly(true);
      setShowMsg("");
    }
  }, [allEduresponsedata]);

  const skipTenthDistrict =
    selectedCountry === "Others" || isNAOption(selectedState);
  const skipTwelthDistrict =
    selectedCountryTwelth === "Others" || isNAOption(selectedStateTwelth);
  const skipUgDistrict =
    selectednewCountry === "Others" || isNAOption(selectedState1);

  return (
    <Home>
      <div class="right_panel">
        <div class="w100">
          <p className="top_head_styl">{showMsg}</p>
          <h4 className="top_head">
            {getCapitalized(PGEducationDetails.Postgraduate_Programme)}
          </h4>
          <span className="help_link">
            <p>
              <NavLink to={PATHS.RAISEQUERY}>{HELP_TEXT}</NavLink>{" "}
              <Tooltip id="educationhelp">
                <p>{ApplicationViewPage.Help_Tooltip_Text}</p>
              </Tooltip>
              <i
                data-tooltip-id="educationhelp"
                class="fa-solid fa-circle-info"
              ></i>
            </p>
          </span>
        </div>
        <div className="w100 scroll_styl">
          <div class="heading_styl head_font">
            <h4>{getCapitalized(PGEducationDetails.Education_Details)}</h4>
          </div>
          <Loader show={loader} />
          <form onSubmit={handleSubmit(_onSubmit)} disabled={readOnly}>
            <div class="form_sec form_part">
              {/* <div class="heading_styl">
                <h4>{PGEducationDetails.Class_10_Details}</h4>
              </div> */}

              <div class="heading_styl">
                <h4>{PGEducationDetails.Class10and12Details}</h4>
              </div>

              <div className="form_styl table-responsive">
                <table className="edu-table">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Class 10 Details</th>
                      <th>Class 12 Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Name of School / College */}
                    <tr>
                      <td>Name of the School / College</td>
                      <td>
                        <input
                          {...register("schoolNameTenth", {
                            required: "Required",
                          })}
                          disabled={readOnly}
                          className={`${
                            errors.schoolNameTenth ? "error_msg" : ""
                          }`}
                        />
                        {errors.schoolNameTenth && (
                          <div className="error_shown">
                            {errors.schoolNameTenth.message}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          {...register("schoolNameTwelveth", {
                            required: "Required",
                          })}
                          disabled={readOnly}
                          className={`${
                            errors.schoolNameTwelveth ? "error_msg" : ""
                          }`}
                        />
                        {errors.schoolNameTwelveth && (
                          <div className="error_shown">
                            {errors.schoolNameTwelveth.message}
                          </div>
                        )}
                      </td>
                    </tr>

                    {/* Country */}
                    <tr>
                      <td>Country</td>
                      <td>
                        <select
                          {...register("countryTenth", {
                            required: {
                              value: true,
                              message: "Please select value",
                            },
                          })}
                          disabled={readOnly}
                          value={selectedCountry}
                          onChange={(e) => {
                            setSelectedCountry(e.target.value);
                            dispatch(unsavedchanges(e.target.value));
                            clearErrors("countryTenth");
                          }}
                          className={`${
                            errors.countryTenth ? "error_msg" : ""
                          }`}
                        >
                          <option value="">
                            {AppCommon.Dropdown_Default_Option}
                          </option>
                          {pickListVal?.country?.map((c, ind) => (
                            <option key={ind} value={c.key}>
                              {c.value}
                            </option>
                          ))}
                        </select>
                        {selectedCountry === "Others" && (
                          <>
                            <label>
                              {UGEducationDetails.Please_Specify} <span>*</span>
                            </label>
                            <input
                              {...register("otherCountrySpecifyTenth", {
                                required: {
                                  value: true,
                                  message: "Please enter value",
                                },
                              })}
                              autoComplete="off"
                              className={`${
                                errors.otherCountrySpecifyTenth
                                  ? "error_msg"
                                  : ""
                              }`}
                            />
                            {errors.otherCountrySpecifyTenth && (
                              <div className="error_shown">
                                {errors.otherCountrySpecifyTenth?.message}
                              </div>
                            )}
                          </>
                        )}
                        {errors.countryTenth && (
                          <div className="error_shown">
                            {errors.countryTenth.message}
                          </div>
                        )}
                      </td>
                      <td>
                        <select
                          {...register("countryTwelveth", {
                            required: {
                              value: true,
                              message: "Please select value",
                            },
                          })}
                          className={`${
                            errors.countryTwelveth ? "error_msg" : ""
                          }`}
                          disabled={readOnly}
                          value={selectedCountryTwelth}
                          onChange={(e) => {
                            setSelectedCountryTwelth(e.target.value);
                            dispatch(unsavedchanges(e.target.value));
                            clearErrors("countryTwelveth");
                          }}
                        >
                          <option value="">
                            {AppCommon.Dropdown_Default_Option}
                          </option>
                          {pickListVal?.country?.map((c, ind) => (
                            <option key={ind} value={c.key}>
                              {c.value}
                            </option>
                          ))}
                        </select>
                        {selectedCountryTwelth === "Others" && (
                          <>
                            <label>
                              {UGEducationDetails.Please_Specify}{" "}
                              <span class="redstyl">* </span>
                            </label>
                            <input
                              {...register("otherCountrySpecifyTwelveth", {
                                required: {
                                  value: true,
                                  message: "Please enter value",
                                },
                              })}
                              autoComplete="off"
                              className={`${
                                errors.otherCountrySpecifyTwelveth
                                  ? "error_msg"
                                  : ""
                              }`}
                              disabled={readOnly}
                            />
                            {errors.otherCountrySpecifyTwelveth && (
                              <div className="error_shown">
                                {errors.otherCountrySpecifyTwelveth?.message}
                              </div>
                            )}
                          </>
                        )}
                        {errors.countryTwelveth && (
                          <div className="error_shown">
                            {errors.countryTwelveth.message}
                          </div>
                        )}
                      </td>
                    </tr>

                    {/* State/UT */}
                    <tr>
                      <td>State/Union Territory of Residence</td>
                      <td>
                        <select
                          {...register("stateTenth", {
                            required: {
                              value:
                                selectedCountry === "Others" ? false : true,
                              message: "Please select value",
                            },
                          })}
                          className={`${
                            selectedCountry !== "Others" && errors.stateTenth
                              ? "error_msg"
                              : ""
                          }`}
                          value={selectedState}
                          onChange={handleState}
                          disabled={
                            !selectedCountry ||
                            selectedCountry === "Others" ||
                            readOnly
                          }
                        >
                          {selectedCountry === "Others" ? (
                            <option value="">
                              {AppCommon.Dropdown_NA_Option}
                            </option>
                          ) : (
                            <option value="" disabled selected>
                              {AppCommon.Dropdown_Default_Option}
                            </option>
                          )}

                          {selectedCountry !== "Others" &&
                            getSelectableStates(pickListVal?.states).map((stateobj, ind) => (
                              <option value={stateobj.Id} key={ind}>
                                {stateobj.value}
                              </option>
                            ))}
                        </select>
                        {selectedCountry !== "Others" && errors.stateTenth && (
                          <div className="error_shown">
                            {errors.stateTenth?.message}
                          </div>
                        )}
                      </td>
                      <td>
                        <select
                          {...register("stateTwelveth", {
                            required: {
                              value:
                                selectedCountryTwelth === "Others" ? false : true,
                              message: "Please select value",
                            },
                          })}
                          value={selectedStateTwelth}
                          onChange={handlenewStateTwelth}
                          disabled={
                            !selectedCountryTwelth ||
                            selectedCountryTwelth === "Others" ||
                            readOnly
                          }
                          className={`${
                            selectedCountryTwelth !== "Others" &&
                            errors.stateTwelveth
                              ? "error_msg"
                              : ""
                          }`}
                        >
                          {selectedCountryTwelth === "Others" ? (
                            <option value="">
                              {AppCommon.Dropdown_NA_Option}
                            </option>
                          ) : (
                            <option value="" disabled selected>
                              {AppCommon.Dropdown_Default_Option}
                            </option>
                          )}
                          {selectedCountryTwelth !== "Others" &&
                            getSelectableStates(pickListVal?.states).map((stateobj, ind) => (
                              <option value={stateobj.Id} key={ind}>
                                {stateobj.value}
                              </option>
                            ))}
                        </select>
                        {selectedCountryTwelth !== "Others" &&
                          errors.stateTwelveth && (
                            <div className="error_shown">
                              {errors.stateTwelveth?.message}
                            </div>
                          )}
                      </td>
                    </tr>

                    {/* District/City */}
                    <tr>
                      <td>District / City</td>
                      <td>
                        <select
                          {...register("districtTenth", {
                            required: {
                              value: skipTenthDistrict ? false : true,
                              message: "Please select value",
                            },
                          })}
                          value={selectedDistrict}
                          onChange={(e) => {
                            setSelectedDistrict(e.target.value);
                            dispatch(unsavedchanges(e.target.value));
                            clearErrors("districtTenth");
                          }}
                          disabled={
                            !selectedState || skipTenthDistrict || readOnly
                          }
                          className={`${
                            !skipTenthDistrict && errors.districtTenth
                              ? "error_msg"
                              : ""
                          }`}
                        >
                          {skipTenthDistrict ? (
                            <option value="">
                              {AppCommon.Dropdown_NA_Option}
                            </option>
                          ) : (
                            <option disabled selected value="">
                              {AppCommon.Dropdown_Default_Option}
                            </option>
                          )}
                          {!skipTenthDistrict &&
                            district &&
                            district?.map((distObj, ind) => (
                              <option key={ind} value={distObj.Id}>
                                {distObj.Name}
                              </option>
                            ))}
                        </select>
                        {!skipTenthDistrict && errors.districtTenth && (
                          <div className="error_shown">
                            {errors.districtTenth?.message}
                          </div>
                        )}
                      </td>
                      <td>
                        <select
                          {...register("districtTwelveth", {
                            required: {
                              value: skipTwelthDistrict ? false : true,
                              message: "Please select value",
                            },
                          })}
                          value={selectedDistrictTwelth}
                          onChange={(e) => {
                            setSelectedDistrictTwelth(e.target.value);
                            dispatch(unsavedchanges(e.target.value));
                            clearErrors("districtTwelveth");
                          }}
                          className={`${
                            !skipTwelthDistrict && errors.districtTwelveth
                              ? "error_msg"
                              : ""
                          }`}
                          disabled={
                            !selectedStateTwelth ||
                            skipTwelthDistrict ||
                            readOnly
                          }
                        >
                          {skipTwelthDistrict ? (
                            <option value="">
                              {AppCommon.Dropdown_NA_Option}
                            </option>
                          ) : (
                            <option disabled selected value="">
                              {AppCommon.Dropdown_Default_Option}
                            </option>
                          )}
                          {!skipTwelthDistrict &&
                            districtTwelth &&
                            districtTwelth?.map((distObj, ind) => (
                              <option key={ind} value={distObj.Id}>
                                {distObj.Name}
                              </option>
                            ))}
                        </select>
                        {!skipTwelthDistrict && errors.districtTwelveth && (
                          <div className="error_shown">
                            {errors.districtTwelveth?.message}
                          </div>
                        )}
                      </td>
                    </tr>

                    {/* Board */}
                    <tr>
                      <td>School / College Board</td>
                      <td>
                        <select
                          {...register("boardTenth", {
                            required: {
                              value: true,
                              message: "Please select value",
                            },
                          })}
                          onChange={(e) => {
                            dispatch(unsavedchanges(e.target.value));
                            clearErrors("boardTenth");
                          }}
                          className={`${errors.boardTenth ? "error_msg" : ""}`}
                          disabled={readOnly}
                        >
                          <option value="" disabled selected>
                            {AppCommon.Dropdown_Default_Option}
                          </option>
                          {pickListVal &&
                            [...pickListVal?.schlClgBoard]
                              .sort((a, b) => {
                                if (a.value === "OTHERS") return 1; // push "OTHERS" down
                                if (b.value === "OTHERS") return -1; // keep others above
                                return 0;
                              })
                              ?.map((edu, ind) => (
                                <option value={edu.value}>{edu.value}</option>
                              ))}
                        </select>
                        {errors.boardTenth && (
                          <div className="error_shown">
                            {errors.boardTenth?.message}
                          </div>
                        )}
                      </td>
                      <td>
                        <select
                          {...register("boardTwelth", {
                            required: {
                              value: true,
                              message: "Please select value",
                            },
                          })}
                          onChange={(e) => {
                            dispatch(unsavedchanges(e.target.value));
                            clearErrors("boardTwelth");
                          }}
                          className={`${errors.boardTwelth ? "error_msg" : ""}`}
                          disabled={readOnly}
                        >
                          <option value="" disabled selected>
                            {AppCommon.Dropdown_Default_Option}
                          </option>
                          {pickListVal &&
                            [...pickListVal?.schlClgBoard]
                              .sort((a, b) => {
                                if (a.value === "OTHERS") return 1; // push "OTHERS" down
                                if (b.value === "OTHERS") return -1; // keep others above
                                return 0;
                              })
                              ?.map((edu, ind) => (
                                <option value={edu.value}>{edu.value}</option>
                              ))}
                        </select>
                        {errors.boardTwelth && (
                          <div className="error_shown">
                            {errors.boardTwelth?.message}
                          </div>
                        )}
                      </td>
                    </tr>

                    {/* Year of Passing */}
                    <tr>
                      <td>Year of Passing</td>
                      <td>
                        <input
                          {...register("passingYearTenth", {
                            required: {
                              value: true,
                              message: "Please enter value",
                            },
                            pattern: {
                              value: NUM_REGEX,
                              message:
                                "Your entry does not match the allowed pattern.",
                            },
                            maxLength: {
                              value: 4,
                              message: "Please enter valid year",
                            },
                            minLength: {
                              value: 4,
                              message: "Please enter valid year",
                            },
                          })}
                          autocomplete="off"
                          maxLength="4"
                          onChange={(e) => {
                            dispatch(unsavedchanges(e.target.value));
                            clearErrors("passingYearTenth");
                          }}
                          disabled={readOnly}
                          className={`${
                            errors.passingYearTenth ? "error_msg" : ""
                          }`}
                        />
                        {errors.passingYearTenth && (
                          <div className="error_shown">
                            {errors.passingYearTenth?.message}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          {...register("passingYearTwelveth", {
                            required: {
                              value: true,
                              message: "Please enter value",
                            },
                            pattern: {
                              value: NUM_REGEX,
                              message:
                                "Your entry does not match the allowed pattern.",
                            },
                            maxLength: {
                              value: 4,
                              message: "Please enter valid year",
                            },
                            minLength: {
                              value: 4,
                              message: "Please enter valid year",
                            },
                          })}
                          maxLength="4"
                          onChange={(e) => {
                            dispatch(unsavedchanges(e.target.value));
                            clearErrors("passingYearTwelveth");
                          }}
                          disabled={readOnly}
                          className={`${
                            errors.passingYearTwelveth ? "error_msg" : ""
                          }`}
                          autocomplete="off"
                        />
                        {errors.passingYearTwelveth && (
                          <div className="error_shown">
                            {errors.passingYearTwelveth?.message}
                          </div>
                        )}
                      </td>
                    </tr>

                    {/* Type of school clg */}
                    <tr>
                      <td>Type of School/College Board</td>
                      <td>
                        <select
                          {...register("schoolTypeTenth", {
                            required: {
                              value: true,
                              message: "Please select value",
                            },
                          })}
                          onChange={(e) => {
                            dispatch(unsavedchanges(e.target.value));
                            clearErrors("schoolTypeTenth");
                          }}
                          disabled={readOnly}
                          className={`${
                            errors.schoolTypeTenth ? "error_msg" : ""
                          }`}
                        >
                          <option value="" disabled selected>
                            {AppCommon.Dropdown_Default_Option}
                          </option>
                          {pickListVal &&
                            pickListVal?.typeOfSchlBoard?.map((edu, ind) => (
                              <option key={ind} value={edu.value}>
                                {edu.value}
                              </option>
                            ))}
                        </select>
                        {errors.schoolTypeTenth && (
                          <div className="error_shown">
                            {errors.schoolTypeTenth?.message}
                          </div>
                        )}
                      </td>
                      <td>
                        <select
                          {...register("schoolTypeTwelveth", {
                            required: {
                              value: true,
                              message: "Please select value",
                            },
                          })}
                          onChange={(e) => {
                            dispatch(unsavedchanges(e.target.value));
                            clearErrors("schoolTypeTwelveth");
                          }}
                          disabled={readOnly}
                          className={`${
                            errors.schoolTypeTwelveth ? "error_msg" : ""
                          }`}
                        >
                          <option value="" disabled selected>
                            {AppCommon.Dropdown_Default_Option}
                          </option>
                          {pickListVal &&
                            pickListVal?.typeOfSchlBoard?.map((edu, ind) => (
                              <option key={ind} value={edu.value}>
                                {edu.value}
                              </option>
                            ))}
                        </select>
                        {errors.schoolTypeTwelveth && (
                          <div className="error_shown">
                            {errors.schoolTypeTwelveth?.message}
                          </div>
                        )}
                      </td>
                    </tr>
                    {/* Medium */}
                    <tr>
                      <td>Medium of Instruction</td>
                      <td>
                        <select
                          {...register("mediumInstTenth", {
                            required: {
                              value: true,
                              message: "Please select value",
                            },
                          })}
                          disabled={readOnly}
                          className={`${
                            errors.mediumInstTenth ? "error_msg" : ""
                          }`}
                          value={tenthMedium}
                          onChange={(e) => {
                            setTenthMedium(e.target.value);
                            dispatch(unsavedchanges(e.target.value));
                            clearErrors("mediumInstTenth");
                          }}
                        >
                          <option value="" disabled selected>
                            {AppCommon.Dropdown_Default_Option}
                          </option>
                          {pickListVal &&
                            [...pickListVal?.mediumOfInstruction]
                              .sort((a, b) => {
                                if (a.value === "Other") return 1; // push "Other" down
                                if (b.value === "Other") return -1; // keep others above
                                return 0;
                              })
                              ?.map((edu, ind) => (
                                <option value={edu.value}>{edu.value}</option>
                              ))}
                        </select>
                        {tenthMedium === "Other" && (
                          <>
                            <label>
                              {UGEducationDetails.Please_Specify}{" "}
                              <span class="redstyl">* </span>
                            </label>
                            <input
                              {...register("specifyMediumTenth", {
                                required: {
                                  value: true,
                                  message: "Please enter value",
                                },
                              })}
                              autoComplete="off"
                              onChange={(e) => {
                                dispatch(unsavedchanges(e.target.value));
                                clearErrors("specifyMediumTenth");
                              }}
                              disabled={readOnly}
                              className={`${
                                errors.specifyMediumTenth ? "error_msg" : ""
                              }`}
                            />
                            {errors.specifyMediumTenth && (
                              <div className="error_shown">
                                {errors.specifyMediumTenth?.message}
                              </div>
                            )}
                          </>
                        )}
                        {errors.mediumInstTenth && (
                          <div className="error_shown">
                            {errors.mediumInstTenth?.message}
                          </div>
                        )}
                      </td>
                      <td>
                        <select
                          {...register("mediumInstTwelveth", {
                            required: {
                              value: true,
                              message: "Please select value",
                            },
                          })}
                          disabled={readOnly}
                          value={twelvthMedium}
                          onChange={(e) => {
                            setTwelvthMedium(e.target.value);
                            dispatch(unsavedchanges(e.target.value));
                            clearErrors("mediumInstTwelveth");
                          }}
                          className={`${
                            errors.mediumInstTwelveth ? "error_msg" : ""
                          }`}
                        >
                          <option value="" disabled selected>
                            {AppCommon.Dropdown_Default_Option}
                          </option>
                          {pickListVal &&
                            [...pickListVal?.mediumOfInstruction]
                              .sort((a, b) => {
                                if (a.value === "Other") return 1; // push "Other" down
                                if (b.value === "Other") return -1; // keep others above
                                return 0;
                              })
                              ?.map((edu, ind) => (
                                <option value={edu.value}>{edu.value}</option>
                              ))}
                        </select>
                        {twelvthMedium === "Other" && (
                          <>
                            <label>
                              {UGEducationDetails.Please_Specify}{" "}
                              <span class="redstyl">* </span>
                            </label>
                            <input
                              {...register("specifyMediumTwelveth", {
                                required: {
                                  value: true,
                                  message: "Please enter value",
                                },
                              })}
                              autoComplete="off"
                              onChange={(e) => {
                                dispatch(unsavedchanges(e.target.value));
                                clearErrors("specifyMediumTwelveth");
                              }}
                              disabled={readOnly}
                              className={`${
                                errors.specifyMediumTwelveth ? "error_msg" : ""
                              }`}
                            />
                            {errors.specifyMediumTwelveth && (
                              <div className="error_shown">
                                {errors.specifyMediumTwelveth?.message}
                              </div>
                            )}
                          </>
                        )}
                        {errors.mediumInstTwelveth && (
                          <div className="error_shown">
                            {errors.mediumInstTwelveth?.message}
                          </div>
                        )}
                      </td>
                    </tr>
                    {/* Category */}
                    <tr>
                      <td>Category of city/town</td>
                      <td>
                        <select
                          {...register("residenceTenth", {
                            required: {
                              value: true,
                              message: "Please select value",
                            },
                          })}
                          onChange={(e) => {
                            dispatch(unsavedchanges(e.target.value));
                            clearErrors("residenceTenth");
                          }}
                          disabled={readOnly}
                          className={`${
                            errors.residenceTenth ? "error_msg" : ""
                          }`}
                        >
                          <option value="" disabled selected>
                            {AppCommon.Dropdown_Default_Option}
                          </option>
                          {pickListVal &&
                            pickListVal?.regionOfResidence?.map((edu, ind) => (
                              <option value={edu.value}>{edu.value}</option>
                            ))}
                        </select>
                        {errors.residenceTenth && (
                          <div className="error_shown">
                            {errors.residenceTenth?.message}
                          </div>
                        )}
                      </td>
                      <td>
                        <select
                          {...register("residenceTwelveth", {
                            required: {
                              value: true,
                              message: "Please select value",
                            },
                          })}
                          onChange={(e) => {
                            dispatch(unsavedchanges(e.target.value));
                            clearErrors("residenceTwelveth");
                          }}
                          disabled={readOnly}
                          className={`${
                            errors.residenceTwelveth ? "error_msg" : ""
                          }`}
                        >
                          <option value="" disabled selected>
                            {AppCommon.Dropdown_Default_Option}
                          </option>
                          {pickListVal &&
                            pickListVal?.regionOfResidence?.map((edu, ind) => (
                              <option value={edu.value}>{edu.value}</option>
                            ))}
                        </select>
                        {errors.residenceTwelveth && (
                          <div className="error_shown">
                            {errors.residenceTwelveth?.message}
                          </div>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

{/* UNDERGRADUATEEEEEEEEEEEEEEEEEEEE -------------------------------------- */}
              <div class="form_styl">
                <div class="w100 blc_txt cat_pg_text">
                  <Notes name="Category_PG" />
                </div>
              </div>

              <div class="heading_styl">
                <h4>{PGEducationDetails.Undergraduate_Details}</h4>
              </div>
              <div class="form_styl">
                <div class="inner_part">
                  <label>
                    {PGEducationDetails.Bachelor_Degree_Completion_Status}{" "}
                    <span class="redstyl">* </span>
                  </label>

                  <select
                    {...register("bachelorsCompletedByAug", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    value={getValues("bachelorsCompletedByAug") || ""}
                    onChange={(e) => {
                      setValue("bachelorsCompletedByAug", e.target.value);
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("bachelorsCompletedByAug");
                    }}
                    disabled={readOnly}
                    className={`${
                      errors.bachelorsCompletedByAug ? "error_msg" : ""
                    }`}
                  >
                    <option disabled selected value="">
                      {AppCommon.Dropdown_Default_Option}
                    </option>
                    {bachelorsStatusYear &&
                      bachelorsStatus &&
 Object.values(bachelorsStatus).map((soci, ind) => {
      // ✅ condition to disable other options
      const isMPH =
        allEduresponsedata?.hed__Applications_Applicant__r?.records[0]
          ?.First_Preference_Name__c === "Master of Public Health";
     const isMBA = allEduresponsedata?.hed__Applications_Applicant__r?.records[0]
     ?.First_Preference_Name__c === "Master of Business Administration (Development Management)";
      const shouldDisable = isMBA && soci !== "Already completed";

      return (
        <option key={ind} value={soci} disabled={shouldDisable}>
          {soci}
        </option>
      );
    })}
                  </select>
                  {errors.bachelorsCompletedByAug && (
                    <div className="error_shown">
                      {errors.bachelorsCompletedByAug?.message}
                    </div>
                  )}
                </div>
               {/* <div class="inner_part notes_class">
                  {allEduresponsedata?.hed__Applications_Applicant__r
                    ?.records[0]?.First_Preference_Name__c ===
                    "Master of Public Health" && (
                    <Notes name="Master_of_Public_Health" />
                  )}
                </div>*/}
              </div>
              <div class="form_styl">
                <div class="inner_part">
                  <label>
                    {PGEducationDetails.Qualification_Obtained}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    {...register("qualificationsObtained", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    onChange={(e) => {
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("qualificationsObtained");
                    }}
                    disabled={
                      allEduresponsedata?.hed__Applications_Applicant__r
                        ?.records[0]?.Not_Eligible__c || readOnly
                      // &&
                      // formattedDate >
                      //   allEduresponsedata?.hed__Applications_Applicant__r
                      //     ?.records[0]?.Admission_Cycle__r
                      //     ?.Preference_End_Date__c
                    }
                    className={`${
                      errors.qualificationsObtained ? "error_msg" : ""
                    }`}
                  >
                    <option disabled selected value="">
                      {AppCommon.Dropdown_Default_Option}
                    </option>
                    {pickListVal &&
                      pickListVal?.qualificationObtained?.map((soci, ind) => (
                        <option value={soci.key}>{soci.value}</option>
                      ))}
                  </select>
                  {errors.qualificationsObtained && (
                    <div className="error_shown">
                      {errors.qualificationsObtained?.message}
                    </div>
                  )}
                </div>
                <div class="inner_part">
                  <label>
                    {PGEducationDetails.Year_Of_Completion}{" "}
                    <span class="redstyl">* </span>
                    <i
                      data-tooltip-id="helpTooltip"
                      class="fa-solid fa-circle-info"
                    ></i>
                    <Tooltip id="helpTooltip">
                      <p>
                        {PGEducationDetails.Year_Of_Completion_Tooltip_Message}
                      </p>
                    </Tooltip>
                  </label>
                  <input
                    {...register("completionYear", {
                      required: {
                        value: true,
                        message: "Please enter value",
                      },
                      pattern: {
                        value: NUM_REGEX,
                        message:
                          "Your entry does not match the allowed pattern.",
                      },
                      maxLength: {
                        value: 4,
                        message: "Please enter valid year",
                      },
                      minLength: {
                        value: 4,
                        message: "Please enter valid year",
                      },
                    })}
                    autoComplete="off"
                    onChange={(e) => {
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("completionYear");
                    }}
                    disabled={readOnly}
                    maxLength="4"
                    className={`${errors.completionYear ? "error_msg" : ""}`}
                  />
                  {errors.completionYear && (
                    <div className="error_shown">
                      {errors.completionYear?.message}
                    </div>
                  )}
                </div>
              </div>

              {allEduresponsedata?.hed__Applications_Applicant__r?.records[0]
                ?.First_Preference_Name__c == "M.A. Economics" && (
                <div class="form_styl">
                  <div class="inner_part">
                    <label>
                      {PGEducationDetails.UG_Economics_Passed_Question}{" "}
                      <span class="redstyl">* </span>
                    </label>
                    <select
                      {...register("HaveUGEconomicsPassed", {
                        required: {
                          value: true,
                          message: "Please select value",
                        },
                      })}
                      onChange={(e) => {
                        dispatch(unsavedchanges(e.target.value));
                        clearErrors("HaveUGEconomicsPassed");
                      }}
                      disabled={
                        allEduresponsedata?.hed__Applications_Applicant__r
                          ?.records[0]?.Not_Eligible__c ||
                        (readOnly &&
                          formattedDate >
                            allEduresponsedata?.hed__Applications_Applicant__r
                              ?.records[0]?.Admission_Cycle__r
                              ?.Preference_End_Date__c)
                      }
                      className={`${
                        errors.HaveUGEconomicsPassed ? "error_msg" : ""
                      }`}
                    >
                      <option disabled selected value="">
                        {AppCommon.Dropdown_Default_Option}
                      </option>
                      {pickListVal &&
                        pickListVal?.haveYouPassedUGEconomics?.map(
                          (soci, ind) => (
                            <option value={soci.key}>{soci.value}</option>
                          )
                        )}
                    </select>
                    {errors.HaveUGEconomicsPassed && (
                      <div className="error_shown">
                        {errors.HaveUGEconomicsPassed?.message}
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div class="form_styl">
                <div class="inner_part">
                  <label>
                    {PGEducationDetails.Duration_of_Undergraduate_Programme}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    {...register("durationUndergraduateProg", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    onChange={(e) => {
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("durationUndergraduateProg");
                    }}
                    disabled={
                      allEduresponsedata?.hed__Applications_Applicant__r
                        ?.records[0]?.Not_Eligible__c || readOnly                      
                    }
                    className={`${
                      errors.durationUndergraduateProg ? "error_msg" : ""
                    }`}
                  >
                    <option disabled selected value="">
                      {AppCommon.Dropdown_Default_Option}
                    </option>
                    {pickListVal &&
                      pickListVal?.durationUG?.map((soci, ind) => (
                        <option value={soci.key}>{soci.value}</option>
                      ))}
                  </select>
                  {errors.durationUndergraduateProg && (
                    <div className="error_shown">
                      {errors.durationUndergraduateProg?.message}
                    </div>
                  )}
                </div>
                <div class="inner_part"></div>
              </div>
              <br />
              <div class="form_styl">
                <div class="w100 blc_txt">
                  <Notes name="Category" />
                </div>
              </div>
              <div class="form_styl">
                <div class="inner_part">
                  <label>
                    {PGEducationDetails.Category_Of_City_UG}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    {...register("townCategoryGrad", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    onChange={(e) => {
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("townCategoryGrad");
                    }}
                    className={`${errors.townCategoryGrad ? "error_msg" : ""}`}
                    disabled={readOnly}
                  >
                    <option disabled selected value="">
                      {AppCommon.Dropdown_Default_Option}
                    </option>
                    {pickListVal &&
                      pickListVal?.regionOfResidence?.map((soci, ind) => (
                        <option value={soci.Id}>{soci.value}</option>
                      ))}
                  </select>
                  {errors.townCategoryGrad && (
                    <div className="error_shown">
                      {errors.townCategoryGrad?.message}
                    </div>
                  )}
                </div>
                <div class="inner_part">
                  <label>
                    {PGEducationDetails.Mode_Of_Graduation}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    {...register("gradMode", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    onChange={(e) => {
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("gradMode");
                    }}
                    className={`${errors.gradMode ? "error_msg" : ""}`}
                    disabled={readOnly}
                  >
                    <option disabled selected value="">
                      {AppCommon.Dropdown_Default_Option}
                    </option>
                    {pickListVal &&
                      pickListVal?.modeOfGraduation?.map((soci, ind) => (
                        <option value={soci.Id}>{soci.value}</option>
                      ))}
                  </select>
                  {errors.gradMode && (
                    <div className="error_shown">
                      {errors.gradMode?.message}
                    </div>
                  )}
                </div>
              </div>
              <div class="form_styl">
                <div class="inner_part">
                  <label>
                    {PGEducationDetails.Stream_UG}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <input
                    type="text"
                    {...register("streamSpecialization", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    autoComplete="off"
                    onChange={(e) => {
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("streamSpecialization");
                    }}
                    disabled={readOnly}
                    className={`${
                      errors.streamSpecialization ? "error_msg" : ""
                    }`}
                  />
                  {errors.streamSpecialization && (
                    <div className="error_shown">
                      {errors.streamSpecialization?.message}
                    </div>
                  )}
                </div>
                <div class="inner_part">
                  <label>
                    {PGEducationDetails.University_Name_UG}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <input
                    type="text"
                    {...register("universityName", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    autoComplete="off"
                    onChange={(e) => {
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("universityName");
                    }}
                    disabled={readOnly}
                    className={`${errors.universityName ? "error_msg" : ""}`}
                  />
                  {errors.universityName && (
                    <div className="error_shown">
                      {errors.universityName?.message}
                    </div>
                  )}
                </div>
              </div>
              <div class="form_styl">
                <div class="inner_part">
                  <label>
                    {PGEducationDetails.College_Name_UG}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <input
                    type="text"
                    {...register("schoolNameGrad", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    autoComplete="off"
                    onChange={(e) => {
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("schoolNameGrad");
                    }}
                    disabled={readOnly}
                    className={`${errors.schoolNameGrad ? "error_msg" : ""}`}
                  />
                  {errors.schoolNameGrad && (
                    <div className="error_shown">
                      {errors.schoolNameGrad?.message}
                    </div>
                  )}
                </div>
                <div class="inner_part">
                  <label>
                    {PGEducationDetails.Country_UG}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    {...register("countryGrad", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    disabled={readOnly}
                    className={`${errors.countryGrad ? "error_msg" : ""}`}
                    value={selectednewCountry}
                    onChange={(e) => {
                      setSelectednewCountry(e.target.value);
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("countryGrad");
                    }}
                  >
                    <option disabled selected value="">
                      {AppCommon.Dropdown_Default_Option}
                    </option>
                    {pickListVal &&
                      pickListVal?.country?.map((soci, ind) => (
                        <option value={soci.Id}>{soci.value}</option>
                      ))}
                  </select>
                  {errors.countryGrad && (
                    <div className="error_shown">
                      {errors.countryGrad?.message}
                    </div>
                  )}
                </div>
              </div>
              <div className="form_styl">
                {selectednewCountry === "Others" && (
                  <div class="inner_part">
                    <label>
                      {PGEducationDetails.Please_Specify}{" "}
                      <span class="redstyl">* </span>
                    </label>
                    <input
                      {...register("otherCountrySpecifyGrad", {
                        required: {
                          value: true,
                          message: "Please select value",
                        },
                      })}
                      autoComplete="off"
                      onChange={(e) => {
                        dispatch(unsavedchanges(e.target.value));
                        clearErrors("otherCountrySpecifyGrad");
                      }}
                      className={`${
                        errors.otherCountrySpecifyGrad ? "error_msg" : ""
                      }`}
                      disabled={readOnly}
                    />
                    {errors.otherCountrySpecifyGrad && (
                      <div className="error_shown">
                        {errors.otherCountrySpecifyGrad?.message}
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div class="form_styl">
                <div class="inner_part">
                  <label>
                    {PGEducationDetails.State_Union_Residence_UG}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    {...register("stateGrad", {
                      required: {
                        value: selectednewCountry === "Others" ? false : true,
                        message: "Please select value",
                      },
                    })}
                    className={`${errors.stateGrad ? "error_msg" : ""}`}
                    value={selectedState1}
                    onChange={handlenewState}
                    disabled={
                      !selectednewCountry ||
                      selectednewCountry === "Others" ||
                      readOnly
                    }
                  >
                    {selectednewCountry === "Others" ? (
                      <option selected disabled value="">
                        {AppCommon.Dropdown_NA_Option}
                      </option>
                    ) : (
                      <option disabled value="">
                        {AppCommon.Dropdown_Default_Option}
                      </option>
                    )}
                    {selectednewCountry !== "Others" &&
                      getSelectableStates(pickListVal?.states).map((stateobj, ind) => (
                        <option value={stateobj.Id} key={ind}>
                          {stateobj.value}
                        </option>
                      ))}
                  </select>
                  {errors.stateGrad && (
                    <div className="error_shown">
                      {errors.stateGrad?.message}
                    </div>
                  )}
                </div>
                <div class="inner_part">
                  <label>
                    {PGEducationDetails.District_UG}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    type="text"
                    {...register("districtGrad", {
                      required: {
                        value: skipUgDistrict ? false : true,
                        message: "Please select value",
                      },
                    })}
                    disabled={skipUgDistrict || readOnly}
                    className={`${errors.districtGrad ? "error_msg" : ""}`}
                    value={selectedDistrict1}
                    onChange={(e) => {
                      setSelectedDistrict1(e.target.value);
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("districtGrad");
                    }}
                  >
                    {skipUgDistrict && (
                      <option disabled selected value="">
                        {AppCommon.Dropdown_NA_Option}
                      </option>
                    )}
                    {!skipUgDistrict && (
                      <option disabled value=""></option>
                    )}
                    {!skipUgDistrict &&
                      district1 &&
                      district1?.map((distObj, ind) => (
                        <option key={ind} value={distObj.Id}>
                          {distObj.Name}
                        </option>
                      ))}
                  </select>
                  {errors.districtGrad && (
                    <div className="error_shown">
                      {errors.districtGrad?.message}
                    </div>
                  )}
                </div>
              </div>
              <div class="form_styl flex-wrap">
                <div class="inner_part">
                  <label>
                    {PGEducationDetails.Medium_Of_Instruction_UG}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    {...register("mediumInstGrad", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    disabled={readOnly}
                    className={`${errors.mediumInstGrad ? "error_msg" : ""}`}
                    value={mediumInsti}
                    onChange={(e) => {
                      setMediumInsti(e.target.value);
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("mediumInstGrad");
                    }}
                  >
                    <option disabled selected value="">
                      {AppCommon.Dropdown_Default_Option}
                    </option>
                    {pickListVal &&
                      pickListVal?.mediumOfInstruction?.map((soci, ind) => (
                        <option value={soci.Id}>{soci.value}</option>
                      ))}
                  </select>
                  {errors.mediumInstGrad && (
                    <div className="error_shown">
                      {errors.mediumInstGrad?.message}
                    </div>
                  )}
                </div>
                {mediumInsti === "Other" && (
                  <div class="inner_part">
                    <label>
                      {PGEducationDetails.Please_Specify}{" "}
                      <span class="redstyl">* </span>
                    </label>
                    <input
                      {...register("specifyMediumGrad", {
                        required: {
                          value: true,
                          message: "Please select value",
                        },
                      })}
                      autoComplete="off"
                      onChange={(e) => {
                        dispatch(unsavedchanges(e.target.value));
                        clearErrors("specifyMediumGrad");
                      }}
                      disabled={readOnly}
                      className={`${
                        errors.specifyMediumGrad ? "error_msg" : ""
                      }`}
                    />
                    {errors.specifyMediumGrad && (
                      <div className="error_shown">
                        {errors.specifyMediumGrad?.message}
                      </div>
                    )}
                  </div>
                )}
                <div class="inner_part">
                  <label>
                    {PGEducationDetails.PG_Degree_Question}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    {...register("havePGDegree", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    className={`${errors.havePGDegree ? "error_msg" : ""}`}
                    value={pgDegree}
                    onChange={(e) => {
                      setPgdegree(e.target.value);
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("havePGDegree");
                    }}
                    disabled={readOnly}
                  >
                    <option disabled selected value="">
                      {AppCommon.Dropdown_Default_Option}
                    </option>
                    {pickListVal &&
                      pickListVal?.doYouHavePostGradDegree?.map((soci, ind) => (
                        <option value={soci.Id}>{soci.value}</option>
                      ))}
                  </select>
                  {errors.havePGDegree && (
                    <div className="error_shown">
                      {errors.havePGDegree?.message}
                    </div>
                  )}
                </div>
              </div>

              {pgDegree == "Yes" && (
                <div class="form_styl">
                  <div class="inner_part">
                    <label>
                      {PGEducationDetails.PG_Degree_Name}{" "}
                      <span class="redstyl">* </span>
                    </label>
                    <input
                      type="text"
                      {...register("qualificationName", {
                        required: {
                          value: true,
                          message: "Please select value",
                        },
                      })}
                      autoComplete="off"
                      onChange={(e) => {
                        dispatch(unsavedchanges(e.target.value));
                        clearErrors("qualificationName");
                      }}
                      disabled={readOnly}
                      className={`${
                        errors.qualificationName ? "error_msg" : ""
                      }`}
                    />
                    {errors.qualificationName && (
                      <div className="error_shown">
                        {errors.qualificationName?.message}
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div class="heading_styl">
                <h4>{PGEducationDetails.Work_Experience}</h4>
              </div>
              <div class="form_styl">
                <div class="inner_part">
                  <label>
                    {PGEducationDetails.Experience_After_Graduation_Question}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    {...register("workExperience", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    disabled={readOnly}
                    className={`${errors.workExperience ? "error_msg" : ""}`}
                    onChange={(e) => {
                      handleExprience(e);
                    }}
                  >
                    <option disabled selected value="">
                      {AppCommon.Dropdown_Default_Option}
                    </option>
                    {pickListVal &&
                      pickListVal?.workExpAfterGraduation?.map((soci, ind) => (
                        <option value={soci.Id}>{soci.value}</option>
                      ))}
                  </select>
                  {errors.workExperience && (
                    <div className="error_shown">
                      {errors.workExperience?.message}
                    </div>
                  )}
                </div>
                {experience === "Yes" && (
                  <div class="inner_part">
                    <label>
                      {PGEducationDetails.Currently_Employed_Question}{" "}
                      <span class="redstyl">* </span>
                    </label>
                    <select
                      {...register("AreCurrentlyEmployed", {
                        required: {
                          value: true,
                          message: "Please select value",
                        },
                      })}
                      onChange={(e) => {
                        dispatch(unsavedchanges(e.target.value));
                        clearErrors("AreCurrentlyEmployed");
                      }}
                      className={`${
                        errors.AreCurrentlyEmployed ? "error_msg" : ""
                      }`}
                      disabled={readOnly}
                    >
                      <option disabled selected value="">
                        {AppCommon.Dropdown_Default_Option}
                      </option>
                      {pickListVal &&
                        pickListVal?.areYouCurrentlyEmployeed?.map(
                          (soci, ind) => (
                            <option value={soci.Id}>{soci.value}</option>
                          )
                        )}
                    </select>
                    {errors.AreCurrentlyEmployed && (
                      <div className="error_shown">
                        {errors.AreCurrentlyEmployed?.message}
                      </div>
                    )}
                  </div>
                )}
              </div>
              {experience === "Yes" && (
                <>
                  <div class="form_styl">
                    <div class="inner_part">
                      <label>
                        {PGEducationDetails.Experience_As_On}{" "}
                        {moment(
                          allEduresponsedata?.hed__Applications_Applicant__r
                            .records[0]?.Admission_Cycle__r
                            ?.Work_experience_in_months__c
                        ).format("DD MMMM YYYY")}
                        <span class="redstyl">* </span>
                      </label>
                      <input
                        type="text"
                        {...register("workExperienceInMonths", {
                          required: {
                            value: true,
                            message: "Please select value",
                          },
                          pattern: {
                            value: NUM_REGEX,
                            message: "Work experience should be in Months.",
                          },
                          maxLength: {
                            value: 11,
                            message: "Work experience should be in Months.",
                          },
                          // validate: (val) => {
                          //   if (
                          //     allEduresponsedata?.hed__Applications_Applicant__r
                          //       ?.records[0]?.First_Preference_Name__c ===
                          //       "Master of Public Health" &&
                          //     val < 18
                          //   ) {
                          //     return `Minimum 18 months of experience required to Apply for Master of Public Health.`;
                          //   }
                          // },
                        })}
                        autoComplete="off"
                        maxLength="11"
                        onChange={(e) => {
                          dispatch(unsavedchanges(e.target.value));
                          clearErrors("workExperienceInMonths");
                        }}
                        disabled={readOnly}
                        className={`${
                          errors.workExperienceInMonths ? "error_msg" : ""
                        }`}
                      />
                      {errors.workExperienceInMonths && (
                        <div className="error_shown">
                          {errors.workExperienceInMonths?.message}
                        </div>
                      )}
                      {allEduresponsedata?.hed__Applications_Applicant__r
                        ?.records[0]?.First_Preference_Name__c ===
                        "Master of Business Administration (Development Management)" && (
                        <p>
                          You will be required to submit the experience
                          certificates at the time of joining.
                        </p>
                      )}
                    </div>

                    <div class="inner_part">
                      <label>
                        {PGEducationDetails.Last_Organisation_Name}{" "}
                        <span class="redstyl">* </span>
                      </label>
                      <input
                        type="text"
                        {...register("organization", {
                          required: {
                            value: true,
                            message: "Please select value",
                          },
                        })}
                        autoComplete="off"
                        onChange={(e) => {
                          dispatch(unsavedchanges(e.target.value));
                          clearErrors("organization");
                        }}
                        disabled={readOnly}
                        className={`${errors.organization ? "error_msg" : ""}`}
                      />
                      {errors.organization && (
                        <div className="error_shown">
                          {errors.organization?.message}
                        </div>
                      )}
                    </div>
                  </div>
                  <div class="form_styl">
                    <div class="inner_part">
                      <label>
                        {PGEducationDetails.Last_Organisation_Type}{" "}
                        <span class="redstyl">* </span>
                      </label>
                      <select
                        {...register("typeOfOrganization", {
                          required: {
                            value: true,
                            message: "Please select value",
                          },
                        })}
                        onChange={(e) => {
                          dispatch(unsavedchanges(e.target.value));
                          clearErrors("typeOfOrganization");
                        }}
                        disabled={readOnly}
                        className={`${
                          errors.typeOfOrganization ? "error_msg" : ""
                        }`}
                      >
                        <option disabled selected value="">
                          {AppCommon.Dropdown_Default_Option}
                        </option>
                        {/* {pickListVal &&
                          pickListVal?.typeOfOrganization?.map((soci, ind) => (
                            <option value={soci.Id}>{soci.value}</option>
                          ))} */}
                        {natureDis &&
                          natureDis?.map((soci, ind) => (
                            <option value={soci.Id}>{soci.value}</option>
                          ))}
                      </select>
                      {errors.typeOfOrganization && (
                        <div className="error_shown">
                          {errors.typeOfOrganization?.message}
                        </div>
                      )}
                    </div>
                    <div class="inner_part">
                      <label>
                        {PGEducationDetails.Last_Gross_Annual_Salary}{" "}
                        <span class="redstyl">* </span>
                      </label>
                      <input
                        type="text"
                        {...register("annualGrossSalary", {
                          required: {
                            value: true,
                            message: "Please select value",
                          },
                          pattern: {
                            value: NUM_REGEX,
                            message: "Please enter number only!",
                          },
                        })}
                        autoComplete="off"
                        maxLength="18"
                        onChange={(e) => {
                          dispatch(unsavedchanges(e.target.value));
                          clearErrors("annualGrossSalary");
                        }}
                        disabled={readOnly}
                        className={`${
                          errors.annualGrossSalary ? "error_msg" : ""
                        }`}
                      />
                      {errors.annualGrossSalary && (
                        <div className="error_shown">
                          {errors.annualGrossSalary?.message}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div class="form_styl">
                <div class="inner_part">
                  <label>
                    {PGEducationDetails.Worked_With_APF}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    {...register("workedWithApf", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                      onChange: (e) => {
                        dispatch(unsavedchanges(e.target.value));
                        clearErrors("workedWithApf");
                        if (e.target.value !== "Yes") {
                          setValue("apfWorkEmail", "");
                          setValue("apfTeamDepartment", "");
                          setValue("apfLocationOfWork", "");
                          clearErrors("apfWorkEmail");
                          clearErrors("apfTeamDepartment");
                          clearErrors("apfLocationOfWork");
                        }
                      },
                    })}
                    disabled={readOnly}
                    className={`${errors.workedWithApf ? "error_msg" : ""}`}
                  >
                    <option disabled selected value="">
                      {AppCommon.Dropdown_Default_Option}
                    </option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  {errors.workedWithApf && (
                    <div className="error_shown">
                      {errors.workedWithApf?.message}
                    </div>
                  )}
                </div>
              </div>
              {workedWithApf === "Yes" && (
                <>
                  <div class="form_styl">
                    <div class="inner_part">
                      <label>
                        {PGEducationDetails.APF_Work_Email}{" "}
                        <span class="redstyl">* </span>
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        disabled={readOnly}
                        className={`${errors.apfWorkEmail ? "error_msg" : ""}`}
                        {...register("apfWorkEmail", {
                          required: {
                            value: true,
                            message: "Please enter value",
                          },
                          pattern: {
                            value: EMAIL_REGEX,
                            message: "Please enter valid email",
                          },
                          validate: (val) =>
                            hasEmailDomain(val, APF_EMAIL_DOMAIN) ||
                            AppCommon.Invalid_Email_Domain,
                          onChange: (e) => {
                            dispatch(unsavedchanges(e.target.value));
                          },
                        })}
                      />
                      {errors.apfWorkEmail && (
                        <div className="error_shown">
                          {errors.apfWorkEmail?.message}
                        </div>
                      )}
                    </div>
                    <div class="inner_part">
                      <label>
                        {PGEducationDetails.Team_Department}{" "}
                        <span class="redstyl">* </span>
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        disabled={readOnly}
                        className={`${
                          errors.apfTeamDepartment ? "error_msg" : ""
                        }`}
                        {...register("apfTeamDepartment", {
                          required: {
                            value: true,
                            message: "Please enter value",
                          },
                          onChange: (e) => {
                            dispatch(unsavedchanges(e.target.value));
                          },
                        })}
                      />
                      {errors.apfTeamDepartment && (
                        <div className="error_shown">
                          {errors.apfTeamDepartment?.message}
                        </div>
                      )}
                    </div>
                  </div>
                  <div class="form_styl">
                    <div class="inner_part">
                      <label>
                        {PGEducationDetails.Location_Of_Work}{" "}
                        <span class="redstyl">* </span>
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        disabled={readOnly}
                        className={`${
                          errors.apfLocationOfWork ? "error_msg" : ""
                        }`}
                        {...register("apfLocationOfWork", {
                          required: {
                            value: true,
                            message: "Please enter value",
                          },
                          onChange: (e) => {
                            dispatch(unsavedchanges(e.target.value));
                          },
                        })}
                      />
                      {errors.apfLocationOfWork && (
                        <div className="error_shown">
                          {errors.apfLocationOfWork?.message}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div class="form_styl">
                <div class="w100">
                  <button
                    onClick={(e) => (DraftBtn = e.target.value)}
                    value="draft"
                    type="submit"
                    class={
                      allEduresponsedata?.hed__Applications_Applicant__r
                        ?.records[0]?.Not_Eligible__c || readOnly
                        ? // &&
                          // formattedDate >
                          //   allEduresponsedata?.hed__Applications_Applicant__r
                          //     ?.records[0]?.Admission_Cycle__r
                          //     ?.Preference_End_Date__c
                          "submit ml_5 disabled"
                        : "submit ml_5"
                    }
                    disabled={
                      allEduresponsedata?.hed__Applications_Applicant__r
                        ?.records[0]?.Not_Eligible__c || readOnly
                      // &&
                      // formattedDate >
                      //   allEduresponsedata?.hed__Applications_Applicant__r
                      //     ?.records[0]?.Admission_Cycle__r
                      //     ?.Preference_End_Date__c
                    }
                  >
                    {ApplicationViewPage.Draft_Button_Message}
                  </button>
                  <button
                    onClick={(e) => (DraftBtn = e.target.value)}
                    value=""
                    type="submit"
                    class={
                      allEduresponsedata?.hed__Applications_Applicant__r
                        ?.records[0]?.Not_Eligible__c || readOnly
                        ? // &&
                          // formattedDate >
                          //   allEduresponsedata?.hed__Applications_Applicant__r
                          //     ?.records[0]?.Admission_Cycle__r
                          //     ?.Preference_End_Date__c
                          "submit ml_5 disabled"
                        : "submit ml_5"
                    }
                    disabled={
                      allEduresponsedata?.hed__Applications_Applicant__r
                        ?.records[0]?.Not_Eligible__c || readOnly
                      // &&
                      // formattedDate >
                      //   allEduresponsedata?.hed__Applications_Applicant__r
                      //     ?.records[0]?.Admission_Cycle__r
                      //     ?.Preference_End_Date__c
                    }
                  >
                    {ApplicationViewPage.Save_And_Proceed_Button_Message}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Home>
  );
};

export default EducationDetail;
